<template>
  <global-dialog-card
    v-model="model"
    :fullscreen="!device.isDesktop"
    :max-width="650"
    :title="$t('order_details')"
  >
    <div class="mt-4">
      <v-row no-gutters class="mb-4">
        <v-col cols="12" v-if="mealImage !== './media/img/no-image.webp'">
          <v-img
            :src="mealImage"
            :aspect-ratio="1"
            class="rounded-lg"
            max-height="300px"
          ></v-img>
        </v-col>
        <v-col cols="12">
          <div class="text-h6 font-weight-bold mb-1">{{ meal.name }}</div>
        </v-col>
        <v-col cols="12" class="text-body-2 mt-4">
          <v-row no-gutters justify="space-between">
            <span style="font-size: 1rem">{{ $t("employee_name") }}:</span>
            <span class="font-weight-bold">
              {{
                [$store.state.user.user.name, $store.state.user.user.lastname]
                  .map((name) => this.toLatin(name))
                  .join(" ")
              }}
            </span>
          </v-row>
          <v-divider class="my-2"></v-divider>
          <v-row no-gutters justify="space-between">
            <span style="font-size: 1rem">{{ $t("delivery_date") }}:</span>
            <span class="font-weight-bold">
              {{ formatDate(dailyMenu.date) }}
            </span>
          </v-row>
          <v-divider class="my-2"></v-divider>
          <v-row no-gutters justify="space-between">
            <span style="font-size: 1rem">{{ $t("shift.shift") }}:</span>
            <span class="font-weight-bold">{{ $t(changeDay(shift)) }}</span>
          </v-row>
          <template v-if="showPrice && meal.price">
            <v-divider class="my-2"></v-divider>
            <v-row no-gutters justify="space-between">
              <span style="font-size: 1rem">{{ $t("price") }}:</span>
              <span class="font-weight-bold">
                {{ meal.price }} {{ restaurantCurrency }}
              </span>
            </v-row>
          </template>
        </v-col>
      </v-row>
    </div>
    <template #actions>
      <primary-button block @click="orderMeal">
        {{ meal.order ? $t("cancel_order") : $t("confirm_order") }}
      </primary-button>
    </template>
  </global-dialog-card>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import moment from "moment";
import hasMenuOrdering from "@/mixins/hasMenuOrdering";
import { changeDay } from "@/utils/dayShiftUtil";

export default {
  name: "CompanyMenuFoodOrderDialog",
  props: {
    meal: {
      type: Object,
      required: true,
    },
    dailyMenu: {
      type: Object,
      required: true,
    },
    shift: {
      type: String,
      required: true,
    },
  },
  mixins: [hasModel, hasMenuOrdering],
  methods: {
    changeDay,
    async orderMeal() {
      await this.orderAction({
        ...this.orderPayload,
        quantity: this.quantity > 0 ? 0 : 1,
      });
      this.model = false;
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY.");
    },
    getShiftText(shift) {
      const shiftMap = {
        "1-smena": "1. Смена",
        "2-smena": "2. Смена",
        "3-smena": "3. Смена",
      };
      return shiftMap[shift] || "1. Смена";
    },
  },
  computed: {
    showPrice() {
      const company = this.$store.state.company;
      if (!company.settings) return false;
      const settings = JSON.parse(company.settings);
      return !!settings?.show_price;
    },
  },
};
</script>
